import React, { useEffect, useState } from 'react';
import fr from 'facet-rest';
import Button from 'Components/UI/Button';
import useUser from 'Context/UserContext';
import PropTypes from 'prop-types';
import CircularProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/CircularProgress';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { navigateToPage } from 'Views/Page/Content/Templates';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const PlannerAccountApplicationButton = ({ className }) => {
  const { displayErrorMessage } = useSnackbarContext();
  const { householdResource } = useSimpleHousehold();
  const { userResource } = useUser();
  const [pageSelfLink, setPageSelfLink] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!userResource) {
      return;
    }

    const load = async () => {
      setIsLoading(true);
      try {
        // be default, use relationship on the user that is not tied to a household
        let relationshipToUse = userResource.relationship(fr.relationships.plannerAccountApplication.name).link('related');
        if (householdResource) {
          // if we have a household, then use relationship on the household
          relationshipToUse = householdResource.relationship(fr.relationships.plannerAccountApplication.name).link('related');
        }

        const [plannerAccountApplicationStep] = await relationshipToUse.get();
        setPageSelfLink(plannerAccountApplicationStep.link('self').url());
        setIsLoading(false);
      } catch (e) {
        displayErrorMessage(e, 'Failed to load account opening');
        setIsLoading(false);
      }
    };

    load();
  }, []);


  return (
    <Button
      className={className}
      variant="contained"
      color="secondary"
      onClick={() => {
        navigateToPage(pageSelfLink, true);
      }}
      test="open-account"
      disabled={isLoading}
      endIcon={isLoading ? <CircularProgress size={16} color="secondary" /> : undefined}
    >
      Open Account
    </Button>
  );
};

PlannerAccountApplicationButton.defaultProps = {
  className: undefined,
};

PlannerAccountApplicationButton.propTypes = {
  className: PropTypes.string,
};

export default PlannerAccountApplicationButton;
